import { render } from "./filters.svg?vue&type=template&id=ad996220"
const script = {}
script.render = render

export default script